import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Overview from './pages/overview/Overview';
import styles from './info.css';
import { useSelector } from 'react-redux';

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Info = ( { props } ) => {
    const {  global:{ quizType } } = useSelector( ( state ) => state );
    return (
        <div className={ styles.wrapper }>
            <Switch>
                <Route
                    exact
                    path={ `/${ quizType }/:quizID/overview/` }
                    component={ () => <Overview { ...props } /> }
                />
            </Switch>
        </div>
    );
};

export default Info;